/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'CportalModule';
const componentName = 'proxy-widget';
const prefix = `${moduleName}.${componentName}`;

export const proxyHeader = `${prefix}.proxyHeader`;
export const cloudServiceSplitProxyLabel = `${prefix}.cloudServiceSplitProxyLabel`;
export const enabledLabel = `${prefix}.enabledLabel`;
export const deactivatedLabel = `${prefix}.deactivatedLabel`;

export const ENGLISH = {
    [proxyHeader]: 'Proxy',
    [cloudServiceSplitProxyLabel]: 'Cloud Services Split Proxy',
    [enabledLabel]: 'Enabled',
    [deactivatedLabel]: 'Deactivated',
};
